import { useMemo } from 'react'
import { useAlchemizeSeedQuestionListQuery } from './queries.generated'

/**
 * Wraps `useAlchemizeSeedQuestionListQuery` and projects the response
 * down to a list of trimmed, non-empty question strings.
 *
 * Skip predicate is `step !== 'smart-seed'` verbatim. The current
 * code fires the query only on smart-seed entry; smart-interests
 * inherits whatever chip set the most recent visit produced.
 * Expanding the predicate would silently change product behavior
 * (separate ticket).
 */
export default function useSeedSuggestions (
  jwt: string | undefined,
  step: string,
): readonly string[] {
  const { data } = useAlchemizeSeedQuestionListQuery({
    context: jwt ? { jwt } : undefined,
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
    skip: !jwt || step !== 'smart-seed',
  })

  return useMemo<readonly string[]>(() => {
    const list = data?.featureSeedQuestionList?.seedQuestions ?? []
    return list
      .map((q) => (q?.question ?? '').trim())
      .filter((s): s is string => s.length > 0)
  }, [data])
}
